import { type FC, type ReactElement, type ReactNode } from 'react';
import cx from 'classnames';

import { IconLayout24 } from 'src/assets/icons/24x24/IconLayout24';
// @ts-expect-error - CustomButton doesn't have TypeScript definitions
import { CUSTOM_BUTTON_COLOR, CustomButton } from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

interface Props {
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>>;
  onSelect: () => void;
  emptyTitle?: ReactNode;
  emptyIcon?: ReactElement;
  buttonLabel?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const SelectFileArea: FC<Props> = ({
  className,
  classes,
  onSelect,
  emptyTitle = 'No file selected',
  emptyIcon,
  buttonLabel = 'Select File',
  disabled,
  loading,
}) => {
  const styles = useStyles({ classes });

  return (
    <div className={cx(styles.root, className)}>
      {!loading && (
        <>
          {emptyIcon || <IconLayout24 />}

          <CustomTypography
            className={styles.title}
            variant={TYPOGRAPHY_VARIANT.regular14}
          >
            {emptyTitle}
          </CustomTypography>
        </>
      )}

      <CustomButton
        className={styles.button}
        onClick={onSelect}
        disabled={disabled}
        loading={loading}
        color={CUSTOM_BUTTON_COLOR.silver}
      >
        {buttonLabel}
      </CustomButton>
    </div>
  );
};

SelectFileArea.displayName = 'SelectFileArea';
